/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { embedsDashboardIdPost$Json } from '../fn/embeds/embeds-dashboard-id-post-json';
import { EmbedsDashboardIdPost$Json$Params } from '../fn/embeds/embeds-dashboard-id-post-json';
import { embedsDashboardIdPost$Plain } from '../fn/embeds/embeds-dashboard-id-post-plain';
import { EmbedsDashboardIdPost$Plain$Params } from '../fn/embeds/embeds-dashboard-id-post-plain';
import { embedsEmbedTokenIdDelete } from '../fn/embeds/embeds-embed-token-id-delete';
import { EmbedsEmbedTokenIdDelete$Params } from '../fn/embeds/embeds-embed-token-id-delete';
import { embedsValidateGet$Json } from '../fn/embeds/embeds-validate-get-json';
import { EmbedsValidateGet$Json$Params } from '../fn/embeds/embeds-validate-get-json';
import { embedsValidateGet$Plain } from '../fn/embeds/embeds-validate-get-plain';
import { EmbedsValidateGet$Plain$Params } from '../fn/embeds/embeds-validate-get-plain';
import { EmbedTokenDto } from '../models/embed-token-dto';
import { EmbedTokenInfoDto } from '../models/embed-token-info-dto';

@Injectable({ providedIn: 'root' })
export class EmbedsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `embedsDashboardIdPost()` */
  static readonly EmbedsDashboardIdPostPath = '/embeds/{dashboardId}';

  /**
   * Create embed token.
   *
   * Creates an embed token for a dashboard so it can be embedded in another app.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `embedsDashboardIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  embedsDashboardIdPost$Plain$Response(params: EmbedsDashboardIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenDto>> {
    const obs = embedsDashboardIdPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create embed token.
   *
   * Creates an embed token for a dashboard so it can be embedded in another app.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `embedsDashboardIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  embedsDashboardIdPost$Plain(params: EmbedsDashboardIdPost$Plain$Params, context?: HttpContext): Observable<EmbedTokenDto> {
    const resp = this.embedsDashboardIdPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmbedTokenDto>): EmbedTokenDto => r.body)
    );
  }

  /**
   * Create embed token.
   *
   * Creates an embed token for a dashboard so it can be embedded in another app.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `embedsDashboardIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  embedsDashboardIdPost$Json$Response(params: EmbedsDashboardIdPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenDto>> {
    const obs = embedsDashboardIdPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create embed token.
   *
   * Creates an embed token for a dashboard so it can be embedded in another app.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `embedsDashboardIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  embedsDashboardIdPost$Json(params: EmbedsDashboardIdPost$Json$Params, context?: HttpContext): Observable<EmbedTokenDto> {
    const resp = this.embedsDashboardIdPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmbedTokenDto>): EmbedTokenDto => r.body)
    );
  }

  /** Path part for operation `embedsEmbedTokenIdDelete()` */
  static readonly EmbedsEmbedTokenIdDeletePath = '/embeds/{embedTokenId}';

  /**
   * Revoke embed token.
   *
   * Revokes an embed token so it can no longer be used.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `embedsEmbedTokenIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsEmbedTokenIdDelete$Response(params: EmbedsEmbedTokenIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = embedsEmbedTokenIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revoke embed token.
   *
   * Revokes an embed token so it can no longer be used.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `embedsEmbedTokenIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsEmbedTokenIdDelete(params: EmbedsEmbedTokenIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.embedsEmbedTokenIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `embedsValidateGet()` */
  static readonly EmbedsValidateGetPath = '/embeds/validate';

  /**
   * Validate embed token.
   *
   * Validates an embed token, typically called by the embedded client.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `embedsValidateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsValidateGet$Plain$Response(params?: EmbedsValidateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenInfoDto>> {
    const obs = embedsValidateGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Validate embed token.
   *
   * Validates an embed token, typically called by the embedded client.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `embedsValidateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsValidateGet$Plain(params?: EmbedsValidateGet$Plain$Params, context?: HttpContext): Observable<EmbedTokenInfoDto> {
    const resp = this.embedsValidateGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmbedTokenInfoDto>): EmbedTokenInfoDto => r.body)
    );
  }

  /**
   * Validate embed token.
   *
   * Validates an embed token, typically called by the embedded client.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `embedsValidateGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsValidateGet$Json$Response(params?: EmbedsValidateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenInfoDto>> {
    const obs = embedsValidateGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Validate embed token.
   *
   * Validates an embed token, typically called by the embedded client.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `embedsValidateGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  embedsValidateGet$Json(params?: EmbedsValidateGet$Json$Params, context?: HttpContext): Observable<EmbedTokenInfoDto> {
    const resp = this.embedsValidateGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EmbedTokenInfoDto>): EmbedTokenInfoDto => r.body)
    );
  }

}
